import styled from "@emotion/styled";

export const HeaderSectionContainer = styled.div`
    display: flex;
    padding: 0 0 16px;
`;
